<template>
  <div class="admin-translate">
    <header-title title="Traducciones Menús"></header-title>
    <v-row align="start">
      <v-col cols="12" sm="6" md="3" lg="3">
        <v-text-field
          outlined
          dense
          label="Buscar"
          v-model="search"
          class="select-box ml-2"
          prepend-inner-icon="mdi-magnify"
        ></v-text-field>
      </v-col>
    </v-row>
    <Loader :dialog-loader="dialogLoader" message="Cargando..."></Loader>
    <v-container fluid>
      <template>
        <div v-for="menugroup in paginatedData" :key="menugroup.id">
          <TranslateCartasPrincipales
            :data="menugroup"
            @saveToCollection="saveToMenuGroupCollection"
          ></TranslateCartasPrincipales>
        </div>
        <div class="text-center">
          <v-pagination
            v-model="pageNumber"
            :length="Math.ceil(filteredMenuGroup.length / size)"
            circle
            @input="nextPage"
            :total-visible="6"
            color="black"
          ></v-pagination>
        </div>
      </template>
    </v-container>
  </div>
</template>
<script>
import Loader from "../../../components/common/Loader";
import HeaderTitle from "@/components/admin/common/HeaderTitle.vue";
import TranslateCartasPrincipales from "@/components/admin/translate/TranslateCartasPrincipales";
import { updateMenuGroup, menuGroupCollection } from "@/collections/menuGroup";
import { updateUiMenuOrder } from "@/collections/uiMenuOrder";
export default {
  name: "TranslateMenus",
  components: {
    HeaderTitle,
    Loader,
    TranslateCartasPrincipales
  },
  data() {
    return {
      dialogLoader: false,
      search: "",
      menuGroupCollection: [],
      pageNumber: 1,
      size: 2
    };
  },
  firestore() {
    return {
      menuGroupCollection: menuGroupCollection
    };
  },
  mounted() {
    setTimeout(() => {
      this.dialogLoader = false;
    }, 1000);
  },
  computed: {
    filteredMenuGroup() {
      let _menuGroup = [...this.menuGroupCollection];

      return this.search
        ? _menuGroup.filter(menugroup =>
            menugroup?.name?.toLowerCase().includes(this.search?.toLowerCase())
          )
        : _menuGroup;
    },
    paginatedData() {
      let start = this.pageNumber * this.size - this.size;
      let end = start + this.size;
      return this.filteredMenuGroup.slice(start, end);
    }
  },
  methods: {
    nextPage(page) {
      this.pageNumber = page;
    },
    async saveToMenuGroupCollection(input) {
      try {
        await updateMenuGroup(input.id, input);
        await updateUiMenuOrder(input.id, input);
        this.showSuccessMessage("Traducciones Menús actualizado");
      } catch (error) {
        this.setlogError(
          "update_ui_menu_order/update_menu_Group",
          "Obtained error message in saveToMenuGroupCollection()",
          error.stack,
          this.$options.name
        );
        this.showErrorMessage("Algo salió mal");
      }
    }
  }
};
</script>
